import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DragAndDropArea from "nlib/ui/DragAndDropArea";
import Platforms from "utils/Platforms";
import React from "react";
import classNames from "classnames";

const CustomDropArea = ({ disabled, title, fileTypesList, hint, onChange, className, ...restProps }) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  return (
    <DragAndDropArea
      multiple
      disabled={disabled}
      className={classNames(Css.customDropArea, className)}
      onChange={onChange}
      {...restProps}>
      {() => (
        <div className={Css.content}>
          <div className={Css.title}>
            <Icons.FileText />
            <span>{title || (Platforms.checkIsTouchDevice()
              ? messages.fileUploadDescription
              : messages.fileDropDescription)}</span>
          </div>
          <div className={Css.info}>
            <div>{uiTexts.supportedFormats}:</div>
            <div className={Css.fileTypes}>
              {fileTypesList || String(uiTexts.anyType).toLowerCase()}
            </div>
          </div>
          {hint && <div className={Css.info}>{hint}</div>}
        </div>
      )}
    </DragAndDropArea>
  );
};

export default React.memo(CustomDropArea);
